import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-50">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] px-4 py-4 sm:py-3" data-id="element-51">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-0" data-id="element-52">
            <div className="hidden sm:flex flex-col" data-id="element-53">
              <span className="font-serif font-bold text-charcoal text-lg" data-id="element-54">
                China Sin Estrés (2026)
              </span>
              <span className="text-xs text-charcoal-light" data-id="element-55">
                Kit Anti-Bloqueo + Itinerarios
              </span>
            </div>

            <div className="flex items-center w-full sm:w-auto justify-between sm:justify-end gap-4" data-id="element-56">
              <div className="flex flex-col items-end sm:hidden" data-id="element-57">
                <span className="font-bold text-charcoal" data-id="element-58">24€</span>
              </div>

              <div className="flex items-center gap-4 w-full sm:w-auto" data-id="element-59">
                <span className="hidden sm:block font-bold text-xl text-charcoal mr-2" data-id="element-60">
                  24€
                </span>
                <button onClick={() => document.getElementById('checkout')?.scrollIntoView({
              behavior: 'smooth'
            })} className="flex-1 sm:flex-none bg-china-red hover:bg-china-red-dark text-white font-bold py-3 px-6 rounded-lg shadow-md transition-colors flex items-center justify-center whitespace-nowrap" data-id="element-61">
                  Descargar ahora
                  <ArrowRight className="ml-2 h-4 w-4" data-id="element-62" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}